<template>
  <el-container id="glUserSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="div_main">
      <el-main style="background: #FFFFFF;">
        <p style="font-size:25px;margin-left:25px;font-weight:bold;">{{ h_text }}</p>
        <div style="display:flex;justify-content:center;align-items:center;">
            <span style="width:60px; margin-left:0.5vw; color: #000000; font-size: 13px">
               用户名：
            </span>
          <el-input
            placeholder="请输入姓名"
            style="width:10vw;"
            clearable
            v-model="nickName">
          </el-input>
        </div>
        <div style="display:flex;justify-content:center;align-items:center;margin-top:15px">
            <span style="width:60px;margin-left:0.5vw; color: #000000; font-size: 13px">
               账号：
            </span>
          <el-input
            v-if="h_text==='新增人员'"
            placeholder="请输入账号名称"
            style="width:10vw;"
            clearable
            v-model="zhName">
          </el-input>
          <el-input
            v-else
            placeholder="请输入账号名称"
            style="width:10vw;"
            disabled
            v-model="zhName">
          </el-input>
        </div>
        <div v-if="h_text==='新增人员'"
             style="display:flex;justify-content:center;align-items:center;margin-top:15px">
          <span style="width:60px;margin-left:0.5vw; color: #000000; font-size: 13px">
            密码：
          </span>
          <el-input
            placeholder="请输入密码"
            style="width:10vw;"
            maxlength="30"
            v-model="password">
          </el-input>
        </div>
        <div style="display:flex;justify-content:center;align-items:center;margin-top:15px">
            <span style="width:60px;margin-left:0.5vw; color: #000000; font-size: 13px">
               角色：
            </span>
          <el-select v-model="edi_auth" ref='select1' @click.native="getAuthority"
                     @visible-change='show_change'
                     clearable filterable placeholder="请选择"
                     style="width:10vw;">
            <el-option
              v-for="item in li_auth"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!--        <div v-if="h_text==='修改人员信息'"
                     style="display:flex;justify-content:center;align-items:center;margin-top:15px">
                  <p style="font-weight:bold;">重置密码：</p>
                  <el-button @click="init_pswd" size="medium" type="primary">重置</el-button>
                  <p style="margin-left:5px;font-size:14px">重置后变成(123456)</p>
                </div>-->
        <div>
          <div style="display:flex;justify-content:center;align-items:center;margin-top:55px">
            <el-button @click="onBack" size="medium">取消</el-button>
            <el-button @click="onKeep" size="medium" type="primary">保存</el-button>
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import CryptoJS from 'crypto-js';

export default {
  name:"glUserSon",
  computed:{},
  data(){
    return {
      h_text:"新增人员",
      li_h_text:[
        {"text":"管理设置","colour":"#B7B7B7","pages":""},
        {"text":"人员管理","colour":"#B7B7B7","pages":""}
      ],
      id:"",
      isCtr:true,
      edi_auth:"",
      li_auth:[],
      authPage:1,
      authPageSize:10,
      authTotal:10,
      zhName:"",
      password:"",
      nickName:"" /*账号*/
    };
  },
  methods:{ /*方法存放*/
    handleSelectMenu(path){ /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    show_change(item){
      if(item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    onKeep(){
      if(!this.zhName) {
        this.$message.warning("请先输入账号");
        return;
      } else if(!this.nickName) {
        this.$message.warning("请先输入用户名");
        return;
      } else if(!this.edi_auth) {
        this.$message.warning("请先选择角色");
        return;
      }
      if(this.isCtr) {
        this.isCtr = false;
        if(this.h_text === '新增人员') {
          this.addUser();
        } else {
          this.changeUser();
        }
        setTimeout(() => {
          this.isCtr = true;
        },600);
      }
    },
    addUser(){
      const params = {
        'userName':this.zhName,
        'password':CryptoJS.MD5(this.password).toString(),
        'nickName':this.nickName,
        'authorityId':this.edi_auth,/*角色id*/
        'userStateId':3, /*用户状态*/
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.newSysUser,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加人员成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("添加人员失败");
        }
      });
    },
    changeUser(){
      const params = {
        'id':this.id,
        'userName':this.zhName,
        'nickName':this.nickName,
        'authorityId':this.edi_auth,/*角色id*/
        /*'password': this.password,*/
        /*'userStateId': 0,*/
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.setSysUserInfo,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("修改失败");
        }
      });
    },
    init_pswd(){
      const params = {
        'id':this.id,
        'userName':this.zhName,
        'nickName':this.nickName,
        'authorityId':this.edi_auth,/*角色id*/
        /*'password': this.password,*/
        /*'userStateId': 0,*/
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.changePassword,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack(){
      this.$router.go(-1);
    },
    init_View(){

    },
    getAuthority(){
      if(this.authPage * this.authPageSize > this.authTotal) {
        return;
      }
      const params = {
        'page':this.authPage,
        'pageSize':this.authPageSize
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getAuthorityList,params,headers).then(res => {
        console.log(res.data.data);
        this.authTotal = res.data.data["total"];
        let data = res.data.data.list;
        let l = [];
        for(let i = 0; i < data.length; i++) {
          if(data[i]['authorityName'] === "系统管理员") {
            continue;
          }
          let d = {
            value:data[i]['authorityId'],
            label:data[i]['authorityName']
          };
          l.push(d);
        }
        this.li_auth = l;
        this.authPage += 1;
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取角色信息失败");
        }
      });
    },
    scolling(){ /*下拉更新*/
      let e = this.$refs.select1.$refs.scrollbar.$refs.wrap;
      if(this.loading) return; /*loading为真跳过-防止误触*/
      let loadMore = e.scrollHeight - e.scrollTop <= e.clientHeight;
      if(loadMore) { /*到底时触发 loadMore*/
        this.loadMore();
      }
    },
    loadMore(){
      this.loading = true; // 设置加载状态为 true，防止重复请求
      this.getAuthority();
    }
  },
  mounted(){ /*页面加载时调用*/
    this.getAuthority();
    const value = this.$route.query.key;
    this.$refs.select1.$refs.scrollbar.$refs.wrap.addEventListener('scroll',this.scolling); /*绑定下拉组件方法*/
    console.log(value);
    if(value === "addUser") {
      this.h_text = "新增人员";
    } else {
      this.h_text = "修改人员信息";
      this.id = this.$route.query.id;
      this.zhName = this.$route.query.userName;
      this.nickName = this.$route.query.nickName;
      this.edi_auth = this.$route.query.authorityId;
    }
  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>
#glUserSon {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.div_main {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 80px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/gls/glUserSon.vue